export const LoaderStore = {
  namespaced: true,
  state: {
    loading: false
  },
  actions: {
    show({ commit }) {
      commit("show");
    },
    hide({ commit }) {
      commit("hide");
    }
  },
  mutations: {
    show(state) {
      state.loading = true;
    },
    hide(state) {
      state.loading = false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/global/LoaderStore/LoaderStore.js